export default "__VITE_ASSET__Ca2FtI66__"